import Role from "../../../policies/Role";
import AdminHomePanel from "./AdminHomePanel";
import TeacherHomePanel from "./TeacherHomePanel";
import StudentHomePanel from "./StudentHomePanel";

export default function HomeFallback({ user }) {
  if (
    user?.role === Role.Admin ||
    user?.role === Role.AdminContact
  ) {
    return <AdminHomePanel user={user} />;
  }

  if (user?.role === Role.Teacher) {
    return <TeacherHomePanel user={user} />;
  }

  return <StudentHomePanel user={user} />;
}